/**
 * Parses a WKT (Well-Known Text) polygon string into coordinate arrays
 * suitable for use with mapping libraries like Mapbox GL JS.
 *
 * @param wktPolygon - The WKT polygon string or object to parse
 * @returns Array of coordinate rings, where each ring is an array of [longitude, latitude] pairs
 */
export const parseWKTPolygon = (
  wktPolygon: string | any
): [number, number][][] => {
  try {
    // Convert to string if it's not already
    const polygonStr = wktPolygon.toString()

    // Remove 'POLYGON ((' and '))' from the string
    const coordsStr = polygonStr.replace(/^POLYGON\s*\(\(|\)\)$/g, '')

    // Split into rings (we'll only have one in this case)
    const rings = coordsStr.split('),(').map((ring: string) => {
      // Split the ring into coordinate pairs
      return ring.split(',').map((coord: string) => {
        // Split each coordinate pair into [longitude, latitude]
        const [lng, lat] = coord.trim().split(' ').map(Number)
        return [lng, lat] as [number, number]
      })
    })

    return rings
  } catch (error) {
    console.error('Error parsing WKT polygon:', error)
    return []
  }
}
